class Storage {
  static prefix = 'rfid-station::'

  save(key: string, data: any): void {
    return localStorage.setItem(Storage.prefix + key, JSON.stringify(data))
  }

  load(key: string, defaultValue?: any): any {
    const data = localStorage.getItem(Storage.prefix + key)
    if (data && data !== 'undefined') {
      try {
        return JSON.parse(data)
      } catch {
        localStorage.removeItem(Storage.prefix + key)
        return defaultValue
      }
    }
    return defaultValue
  }

  remove(key: string): void {
    return localStorage.removeItem(Storage.prefix + key)
  }

  purgeAllData(): void {
    return localStorage.clear()
  }
}

export const StorageKeyName = (key: string): string => {
  return Storage.prefix + key
}

export default new Storage()
